<template>
  <b-row>
    <b-col sm="3">
      <strong>Areas of Interest</strong>
      <p>Select the appropriate areas of interest for this opportunity.</p>
    </b-col>
    <b-col sm="9">
      <b-alert :show="!opportunityTypeId" variant="warning">
        To complete this portion of the form, you must first select a Type in the Details tab.
      </b-alert>

      <b-form class="form-horizontal">
        <b-form-group v-for="category in validCategories"
                      :key="category.areaOfInterestCategoryId"
                      :label="category.name"
                      label-class="control-label opportunity-form-label">
          <div v-for="area in category.areaOfInterest"
               :key="area.areaOfInterestId">
            <b-form-checkbox v-model="opportunityAreaOfInterests"
                             :value="{areaOfInterestId: area.areaOfInterestId}"
                             v-if="isValidAreaOfInterest(area)">{{ area.name }}</b-form-checkbox>
          </div>
        </b-form-group>

        <slot name="buttons"></slot>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {};
  },

  props: {
    categories: {
      type: Array,
      required: true
    },

    opportunity: {
      type: Object
    }
  },

  watch: {
    opportunity: function() {
      var aoi = [];
      _.forEach(this.opportunity.opportunityAreaOfInterests, function(
        opportunityAreaOfInterest
      ) {
        aoi.push({
          areaOfInterestId: opportunityAreaOfInterest.areaOfInterestId
        });
      });
      this.opportunityAreaOfInterests = aoi;
    },

    opportunityTypeId: function() {
      var that = this;
      // if opportunity type has been selected, remove areas of interest that are invalid for it
      if (this.opportunityTypeId) {
        this.opportunityAreaOfInterests = _.reject(
          this.opportunityAreaOfInterests,
          function(opportunityAreaOfInterest) {
            var areaOfInterest = _.find(that.areasOfInterest, function(aoi) {
              return (
                aoi.areaOfInterestId ===
                opportunityAreaOfInterest.areaOfInterestId
              );
            });
            return areaOfInterest
              ? !that.isValidAreaOfInterest(areaOfInterest)
              : false;
          }
        );
      }
    }
  },

  computed: {
    opportunityAreaOfInterests: {
      get() {
        return this.$store.state.opportunityForm.opportunity
          .opportunityAreaOfInterests;
      },
      set(value) {
        this.$store.commit("updateOpportunityAreaOfInterests", value);
      }
    },

    opportunityTypeId: function() {
      return this.$store.state.opportunityForm.opportunity.opportunityTypeId;
    },

    areasOfInterest: function() {
      var areaOfInterestArray = [];
      _.forEach(this.categories, function(category) {
        areaOfInterestArray = areaOfInterestArray.concat(
          category.areaOfInterest
        );
      });
      return areaOfInterestArray;
    },

    // categories containing at least one valid area of interest
    validCategories: function() {
      var that = this;
      return _.filter(this.categories, function(category) {
        var hasValidAoi = false;
        _.forEach(category.areaOfInterest, function(areaOfInterest) {
          if (that.isValidAreaOfInterest(areaOfInterest)) {
            hasValidAoi = true;
          }
        });
        return hasValidAoi;
      });
    }
  },

  methods: {
    // determines whether area of interest can be selected, given the selected opportunity type
    isValidAreaOfInterest: function(areaOfInterest) {
      var that = this;
      var foundMatch = _.find(
        areaOfInterest.opportunityTypeAreaOfInterests,
        function(opportunityTypeAreaOfInterest) {
          return (
            opportunityTypeAreaOfInterest.opportunityTypeId ===
            that.opportunityTypeId
          );
        }
      );
      return foundMatch;
    }
  }
};
</script>

<style scoped>
</style>
